import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import SeparatorSelect from "./SeparatorSelect";

const GeneratorView = ({
  onGenerate,
  options: initOptions,
  optionsView: OptionsView,
  strings,
  toolStrings,
}) => {
  const [text, setText] = useState("");
  const [separator, setSeparator] = useState("newline");
  const [options, setOptions] = useState(initOptions || {});

  const seperatorMethods = {
    newline: (items) => items.join("\n"),
    comma: (items) => items.join(","),
    tab: (items) => items.join("\t"),
    space: (items) => items.join(" "),
    twoSpaces: (items) => items.join("  "),
    array: (items) => `[${items.join(",")}]`,
    arrayQuoted: (items) => `[${items.map((i) => `"${i}"`).join(",")}]`,
  };

  const applySeparator = (items) => seperatorMethods[separator](items);

  useEffect(() => {
    const load = async () => setText(applySeparator(await onGenerate(options)));
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const load = async () => setText(applySeparator(await onGenerate(options)));
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options, separator]);

  return (
    <div
      className="container-fluid d-flex flex-column h-100"
      style={{ flex: 1 }}
    >
      {OptionsView && (
        <div className="row" style={{ flex: 0 }}>
          <OptionsView
            options={options}
            strings={strings}
            toolStrings={toolStrings}
            onChange={(opt) => setOptions(opt)}
          />
        </div>
      )}
      <div className="row" style={{ flex: 1 }}>
        <div className="position-relative h-100">
          <textarea
            className="form-control textarea-readonly col-xs-12 col-md-6 h-100"
            readOnly
            value={text}
          />
          <button
            href="#"
            className="btn btn-primary position-absolute"
            style={{ bottom: "1em", right: "2em" }}
            data-bs-toggle="popover"
            data-bs-content="Copied!"
            data-bs-placement="bottom"
            onClick={() => {
              navigator.clipboard.writeText(text);
            }}
          >
            <i className="fa fa-lg fa-copy text-light"></i>
          </button>
        </div>
      </div>
      <div className="row" style={{ flex: 0 }}>
        <div className="col-6 col-md-9 p-2">
          <button
            className="btn btn-primary"
            onClick={async () =>
              setText(applySeparator(await onGenerate(options)))
            }
          >
            {strings.Generate}
          </button>
        </div>
        <div className="col col-6 col-md-3 p-2">
          <SeparatorSelect
            strings={strings}
            value={separator}
            onChange={setSeparator}
          />
        </div>
      </div>
    </div>
  );
};

GeneratorView.propType = {
  onGenerate: PropTypes.func.isRequired,
};

export default GeneratorView;
